
<script>

</script>

<template>
  <div  id="Vue-3-component-no-data-found-banner" class="data-error-message-wrapper">
    <div class="data-error-message"><i class="fa-solid fa-database" style="margin-right:5px; color: #3cb5d7;"></i>
      <div>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<style scoped>

.data-error-message-wrapper {
  background: #ffffff;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
}

.data-error-message {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
  width: 360px;
  margin: 10px auto;
  background: #f6f6f6;
  border-radius: 20px;
  font-size: 20px;
  color: #111111;
  /*border-radius: 20px;*/
  /*height: 40px;*/
  /*background: var(--side-menu-color);*/
  /*color: var(--side-menu-text-color);*/
  /*font-size: 14px;*/
  /*width: max-content;*/
  /*padding: 0 20px 0 20px;*/
  /*justify-content: center;*/
  /*align-items: center;*/
  /*display: flex;*/
}

</style>
